import {FilterOutlined} from '@ant-design/icons'
import SelectInput from '../../common/SelectInput'
import Button from '../../common/Button'
import {useEffect, useRef, useState} from 'react'
import { useIntl } from 'react-intl'
import {getRequest} from '../../../services/base'
import {useParams} from 'react-router-dom'
import {toTitleCase} from '../../../utils/common'
import {Form, Popover} from 'antd'

const ConnectorSearchFilter = (props) => {
  const intl = useIntl();
  const { vehicle } = useParams()
  const { selectedCategory, onCategoryChange } = props
  const [categoryOptions, setCategoryOptions] = useState([])
  const [open, setOpen] = useState(false)
  const popoverContentRef = useRef(null)

  useEffect(() => {
    getConnectorCategory()
  }, [])

  const getConnectorCategory = async () => {
    try {
      let res = await getRequest(`/api/connector/category/?vehicle=${vehicle}`)
      // Must not be left undefined: categoryOptions.map() below runs on every
      // render, not only when the popover opens, so a failed fetch took the
      // whole mapping page down with "Cannot read properties of undefined".
      setCategoryOptions(res?.data || [])
    } catch (e) {
      // Silently handle — category filter will be empty
    }
  }

  const handleSearch = () => {
    props.filterConnector()
    setOpen(false)
  }

  const handleClear = () => {
    onCategoryChange(null)
    if (props.onClear) {
      props.onClear()
    }
    setOpen(false)
  }

  const isFilterActive = !!selectedCategory?.value

  const filterContent = (
    <div ref={popoverContentRef} className="connector-search-filter-content">
      <Form layout="vertical" size="small">
        <SelectInput
          name="category"
          label={intl.formatMessage({id: 'connectorViews.mapping.category'})}
          isRequired={false}
          options={categoryOptions.map((val) => ({
            value: val,
            label: toTitleCase(val),
          }))}
          onChange={(value) => {
            onCategoryChange(value)
          }}
          value={selectedCategory}
          initialValue={selectedCategory?.value}
          getPopupContainer={() => popoverContentRef.current}
        />
      </Form>
      <div className="connector-search-filter-actions">
        {isFilterActive && (
          <Button onClick={handleClear}>
            Clear
          </Button>
        )}
        <Button type="primary" onClick={handleSearch}>
          {intl.formatMessage({id: 'connectorViews.mapping.search'})}
        </Button>
      </div>
    </div>
  )

  return (
    <Popover
      trigger="click"
      placement="bottomRight"
      open={open}
      onOpenChange={(visible) => setOpen(visible)}
      content={filterContent}
      overlayClassName="connector-search-filter-popover"
    >
      <FilterOutlined
        className={`connector-search-filter-icon${isFilterActive ? ' active' : ''}`}
      />
    </Popover>
  )
}

export default ConnectorSearchFilter
